import React from 'react';
import { AlertCircle, RefreshCw } from 'lucide-react';
import { Button } from './ui/button';

export default class TaskDetailsErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }

  componentDidCatch(error, info) {
    console.error('[TaskDetails] Error boundary caught:', error, info);
  }

  render() {
    if (this.state.hasError) {
      return (
        <div className="w-96 bg-white dark:bg-gray-900 border-l border-border flex flex-col items-center justify-center p-8 gap-4">
          <AlertCircle className="w-10 h-10 text-red-500" />
          <div className="text-center">
            <h3 className="font-semibold text-sm">Error al mostrar la incidencia</h3>
            <p className="text-xs text-muted-foreground mt-1">
              {this.state.error?.message || 'Error inesperado al cargar los detalles.'}
            </p>
          </div>
          <Button
            variant="outline"
            size="sm"
            onClick={() => {
              this.setState({ hasError: false, error: null });
              this.props.onClose?.();
            }}
          >
            <RefreshCw className="w-4 h-4 mr-2" />
            Cerrar
          </Button>
        </div>
      );
    }
    return this.props.children;
  }
}
